export const HeadphonesCircleIcon: React.FC = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="34"
			height="34"
			viewBox="0 0 34 34"
			fill="none"
		>
			{/* Koło - pomarańczowe tło */}
			<circle cx="17" cy="17" r="13.75" fill="#F97316" />
			{/* Symbol słuchawek - biały */}
			<path
				d="M17 10.5C13.41 10.5 10.5 13.41 10.5 17V21.25C10.5 21.94 11.06 22.5 11.75 22.5H13.625C14.315 22.5 14.875 21.94 14.875 21.25V18.125C14.875 17.435 14.315 16.875 13.625 16.875H12.375V17C12.375 14.445 14.445 12.375 17 12.375C19.555 12.375 21.625 14.445 21.625 17V16.875H20.375C19.685 16.875 19.125 17.435 19.125 18.125V21.25C19.125 21.94 19.685 22.5 20.375 22.5H22.25C22.94 22.5 23.5 21.94 23.5 21.25V17C23.5 13.41 20.59 10.5 17 10.5Z"
				fill="white"
			/>
		</svg>
	);
};
